"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResizeObserver = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var useResizeObserver = function useResizeObserver() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$defaultWidth = _ref.defaultWidth,
      defaultWidth = _ref$defaultWidth === void 0 ? 0 : _ref$defaultWidth,
      _ref$defaultHeight = _ref.defaultHeight,
      defaultHeight = _ref$defaultHeight === void 0 ? 0 : _ref$defaultHeight;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      element = _useState2[0],
      setElement = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultWidth),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      width = _useState4[0],
      setWidth = _useState4[1];

  var _useState5 = (0, _react.useState)(defaultHeight),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      height = _useState6[0],
      setHeight = _useState6[1]; // Dynamic ref will not rerender and reinitiate ResizeObserver
  // `setElement` is fixing this issue


  var ref = function ref(node) {
    return setElement(node);
  };

  ref.current = element;
  (0, _react.useEffect)(function () {
    if (!element) {
      return;
    }

    var resizeObserver = new ResizeObserver(function (entries) {
      if (!entries.length) {
        return;
      }

      var _entries = (0, _slicedToArray2.default)(entries, 1),
          entry = _entries[0];

      setWidth(entry.contentRect.width);
      setHeight(entry.contentRect.height);
    });
    resizeObserver.observe(element);
    return function () {
      return resizeObserver.disconnect();
    };
  }, [element]);
  return {
    ref: ref,
    width: width,
    height: height
  };
};

exports.useResizeObserver = useResizeObserver;